import React from 'react';
import { Button } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { SaveAuditLogs } from '../../../../../../data/UserAuditLogs';
import { postAPI_GenerateInvite } from '../../../../../../constants/APIs';
import { NotificationManager } from "../../../../../../components/common/react-notifications";

function GenerateInvitationLink({
  id, userName
}) {

  const handleCopy = data => {

    const auditData = {
      groupId: getGroupID(),
      itemId: data,
      action: "Generate Invite link by " + userName,
      content: {},
      logType: "UsersRoles",
      createdBy: userName
    };
    SaveAuditLogs(auditData);
    AxiosAPI({
      method: 'put',
      url: `${postAPI_GenerateInvite}/${data}/generate-invite-link`,
      data: {
      },
    }).then(resnew => {
      navigator.clipboard.writeText(resnew.data.url);
      NotificationManager.success(
        "",
        "Link copied to clipboard.",
        3000,
        null,
        null,
        "success"
      );
    }).catch(err => console.error(err));
  };

  return (

    <Button
      color="primary"
      size="sm"
      onClick={() => handleCopy(id)}
      outline
    >
      Copy Invitation Link
    </Button>

  );
}
const mapStateToProps = ({ settings }) => {
  const { userName } = settings;
  return { userName };
};
export default injectIntl(connect(mapStateToProps, {})(GenerateInvitationLink));
